/** §4.3: which wedstrijddagen an ondersteuner can serve on, and the klassen they would like to play in. */
export const beschikbaarheid = {
  title: "Mijn beschikbaarheid",
  legend: "Wedstrijddagen",
  /**
   * Above the checkboxes rather than in the card description: it is only true once there is
   * something to tick, and it must survive the periode closing.
   */
  uitleg:
    "Geef aan op welke wedstrijddagen je kunt ondersteunen. Je opgave is nog geen vaste plek. De wedstrijdleiders maken de planning met de opgaven van iedereen. Zij kiezen ook je functie, uit de functies waarvoor je bevoegd bent. Hoe meer dagen je aankruist, hoe eerlijker zij het werk kunnen verdelen.",
  dagRegel: "{{niveau}} · {{korps}}",

  /** Optional: a wish the wedstrijdleiders can see, not a place that is reserved. */
  klassen: {
    legend: "Klassen (optioneel)",
    uitleg:
      "Kruis aan bij welke klassen je graag wilt ondersteunen. Je keuze is een wens en geen garantie.",
  },

  /**
   * "Jouw" because the reistijd is measured from this ondersteuner's own postcode, not from the
   * korps organising the dag (ADR-0053).
   */
  reistijdRegel: "jouw reistijd {{reistijd}}",
  reistijdOnbekend: "jouw reistijd is nog niet bekend",
  /** An ondersteuner has never been shown a reistijd before, so say where it is measured from. */
  reistijdUitleg:
    "De reistijd is een schatting van de rijtijd met de auto vanaf je eigen postcode. Klopt de reistijd niet? Geef je juiste postcode dan door aan de wedstrijdleiders.",
  opslaan: "Beschikbaarheid opslaan",
  opgeslagen: "Opgeslagen.",
  geenSeizoen: "Er staat nog geen seizoen klaar.",
  geenDagen: "Deze inschrijfperiode heeft nog geen wedstrijddagen.",

  /** The typed URL and the old bookmark: the front door leaves this card out. */
  geenBevoegdheid: {
    title: "Je bent nog voor geen enkele functie bevoegd",
    description:
      "Zodra je voor een functie bevoegd bent, geef je hier op welke wedstrijddagen je kunt ondersteunen. Vraag de wedstrijdleiders om je bevoegd te maken.",
  },
  errors: {
    periodesOphalen:
      "We konden de inschrijfperiodes niet ophalen. Laad de pagina opnieuw.",
    ophalen:
      "We konden je beschikbaarheid niet ophalen. Laad de pagina opnieuw.",
    opslaan:
      "We konden je beschikbaarheid niet opslaan ({{status}}). Probeer het opnieuw.",
  },
} as const;
